import Layout from '@/layout'

const route = {
  path: '/shortPlayReport',
  component: Layout,
  redirect: '/shortPlayReport/index',
  alwaysShow: true, // will always show the root menu
  name: 'shortPlayReport',
  meta: {
    title: '短剧报表',
    icon: 'SRM',
    roles: [
      'short_report.manage'
    ]
  },
  children: [
    // 图表分析
    {
      path: '/shortPlayReport/releaseGroupList/index',
      component: () => import('@/views/shortPlayReport/releaseGroupList/index.vue'),
      name: 'releaseGroupList',
      meta: {
        title: '投放组列表',
        icon: 'component',
        roles: [
          'short_release_group.manage'
        ]
      }
    },
    {
      path: '/shortPlayReport/operations/index',
      component: () => import('@/views/shortPlayReport/operations/index.vue'),
      name: 'operations',
      meta: {
        title: '运营组列表',
        icon: 'component',
        roles: [
          'short_operation_group.manage'
        ]
      }
    },
    {
      path: '/shortPlayReport/dropLocationList/index',
      component: () => import('@/views/shortPlayReport/dropLocationList/index.vue'),
      name: 'dropLocationList',
      meta: {
        title: '投放位置列表',
        icon: 'component',
        roles: [
          'short_position.manage'
        ]
      }
    },
    {
      path: '/shortPlayReport/bindingRelationList/index',
      component: () => import('@/views/shortPlayReport/bindingRelationList/index.vue'),
      name: 'bindingRelationList',
      meta: {
        title: '绑定关系列表',
        icon: 'component',
        roles: [
          'short_promotion.manage'
        ]
      }
    }, {
      path: '/shortPlayReport/playNovelList/index',
      component: () => import('@/views/shortPlayReport/playNovelList/index.vue'),
      name: 'playNovelList',
      meta: {
        title: '短剧列表',
        icon: 'component',
        roles: [
          'short_novel.manage'
        ]
      }
    }, {
      path: '/shortPlayReport/reportList/index',
      component: () => import('@/views/shortPlayReport/reportList/index.vue'),
      name: 'reportList',
      meta: {
        title: '报表列表',
        icon: 'component',
        roles: [
          'short_report.short_promotion_report'
        ]
      }
    }, {
      path: '/shortPlayReport/totalReportList/index',
      component: () => import('@/views/shortPlayReport/totalReportList/index.vue'),
      name: 'totalReportList',
      meta: {
        title: '总计报表',
        icon: 'component',
        roles: [
          'short_report.short_promotion_total_report'
        ]
      }
    }, {
      path: '/shortPlayReport/reportForm/index',
      component: () => import('@/views/shortPlayReport/reportForm/index.vue'),
      name: 'reportForm',
      meta: {
        title: 'T图列表',
        icon: 'component',
        roles: [
          'short_report.short_promotion_t_report'
        ]
      }
    }
  ]
}

export default route
